import React from "react";

import { Link } from "react-router-dom";

const Contact = () => {
    return (
        <div className="container">
            <div className="nav-left">
                <div className="nav-left-item">
                    <Link to="/" className="nav-left-link">
                        HOME
                    </Link>
                </div>
                <div className="nav-line"></div>
                <div className="nav-left-item nav-copyright">
                    <div class="copyright">©/2022</div>
                </div>
            </div>
            <div className="wrapper wf-section">
                <div className="section-left">
                    <div className="content">
                        <div className="header-mask">
                            <h1 className="header header-large align-left">
                                Hello.
                            </h1>
                        </div>
                        <div className="description-mask">
                            <p className="description">
                                Send me an Email or send me a message on one of
                                my Socials.
                                <br />
                                <br />
                                <a
                                    href="mailto:mile.ristov12@gmail.com"
                                    className="link-blue"
                                >
                                    mile.ristov12@gmail.com
                                </a>
                                <br />
                                <a
                                    href="https://www.linkedin.com/in/mile-ristov"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link is-black"
                                >
                                    Linkedin
                                </a>
                                /
                                <a
                                    href="https://github.com/Mileristov"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link is-black"
                                >
                                    Github
                                </a>
                                <br />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;
